

export const findVehicle = (sasiu, list) => {
    let findIndex = list.findIndex( item => item.serie_sasiu == sasiu);
    return findIndex;
}

const mergeVehicles  = ( vehicle, newVehicle) =>{
    
    let response = {...vehicle, ...newVehicle};
    if (vehicle.hasOwnProperty('car') ) {
        response.car = {...vehicle.car};
    }
    if (newVehicle.hasOwnProperty('car') ) {
        response.car = {...response.car, ...newVehicle.car};
    }
    if (newVehicle.hasOwnProperty('owner') ) {
        response.owner = newVehicle.owner;
    }
    return response;
}

export const saveVehicleHelper = (vehicle, list) => { 

    let newList = [ ...list];
    let index = findVehicle(vehicle.serie_sasiu, list);
    if (index == -1) {
        //new
        if (list.length == 0) {
            newList = [vehicle];
        } else {
            newList.push(vehicle);
        }      
    } 

    newList = newList.map ( item => item.serie_sasiu == vehicle.serie_sasiu ?
            mergeVehicles (item, vehicle)
            :
            {...item, active: false, step: false}
            );
    
    return newList;
}

export const saveFormStorage = (data) => {
    localStorage.setItem('formRCA', JSON.stringify(data));
}

export const loadFormStorage = () => {
    return JSON.parse(localStorage.getItem('formRCA'));
}

export const apiDataFromVehicle = (vehicle) => {
    let apiData  = {};
    for (const [key, val] of Object.entries(vehicle)) {
        if (typeof val == 'object') {
            apiData[key] = {};
            for (const [field, value] of Object.entries(val)) {
                if ( field=='tip_inmatriculare' ) {
                    apiData[key][field] = value ? value.value : null;
                } else if ( field =='subcategorie_auto' ) {
                    apiData[key][field] = value ? value.id_api : null;
                } else if ( field=='marca_auto') {
                    apiData[key][field] = value ? value.denumire : null;
                } else if ( field=='combustibil' ) {
                    apiData[key][field] = value ? value.denumire_api : null;
                } else if ( field =='leasing_company_id') {
                    apiData[key][field] = value ? value.id : null;
                } else if ( field =='caen') {
                    apiData[key][field] = value ? value.cod : null;
                } else if ( field =='categorie_pj') {
                    apiData[key][field] = value ? value.value : null;
                } else if ( field =='Judet') {
                    apiData[key][field] = value ? value.carCode : null;
                } else if ( field =='Localitate') {
                    apiData[key][field] = value ? value.siruta : null;
                }
                 else {
                    apiData[key][field] = value ? value : null;
                }  
            }
            
        } else if (typeof val == 'array') {
            apiData[key] = val;
        }
    }
    return apiData;
}

